export interface ICustomerReferenceRelationship {
  id: string;
  name: string;
  amsReferenceRelationshipType: AmsReferenceRelationshipType;
  amsReferenceRelationshipCode: string;
  deletedDate?: Date;
}

export enum AmsReferenceRelationshipType {
  P = 0, // Personal
  C = 1 // Credit
}

export interface ICustomerReferenceRelationshipWithTypeString extends ICustomerReferenceRelationship {
  typeWithName: string;
}